<template>
    <v-container fluid>
        <v-card class="green lighten-5 pa-1">
            <Title title="通知の管理">
                <v-spacer />
                <TitleButton
                    color="primary"
                    icon="mdi-file-document-outline"
                    name="通知作成"
                    @click="onClickCreate" />
            </Title>
            <v-container fluid class="pa-0">
                <v-row>
                    <v-col>
                        <v-card outlined class="pa-2">
                            <v-tabs
                                v-model="currentTabIndex">
                                <v-tab v-for="item in settingItems" :key="item.tab">
                                    <v-chip v-if="currentTabIndex == item.index" color="green lighten-4" label>
                                        <v-icon>{{item.icon}}</v-icon>
                                        {{item.tab}}                    
                                    </v-chip>
                                    <span v-else>
                                        <v-icon>{{item.icon}}</v-icon>
                                        {{item.tab}}
                                    </span>
                                </v-tab>
                                <v-tab-item>
                                    <List
                                        notificationType="receive"
                                        :notifications="notificationReceiveList" 
                                        @onSelectedNotification="onSelectedReceivedNotification"
                                        @onSelectedDeleteNotifications="onSelectedDeleteReceivedNotifications"
                                        @onMore="onMoreReceiveList" />
                                </v-tab-item>
                                <v-tab-item>
                                    <List 
                                        notificationType="send"
                                        :notifications="notificationSendList" 
                                        @onSelectedNotification="onSelectedSentNotification"
                                        @onSelectedDeleteNotifications="onSelectedDeleteSentNotifications"
                                        @onMore="onMoreSendList" />
                                </v-tab-item>
                            </v-tabs>
                        </v-card>
                    </v-col>
                </v-row>                
            </v-container>
            <Viewer ref="viewer" />
            <NotificationCreator ref="notificationCreator" @onSentNotification="onSentNotification" />
            <Confirm ref="confirm" />
        </v-card>
    </v-container>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import List from '@/components/notification/items/NotificationList';
    import Viewer from '@/components/notification/items/NotificationViewer'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import NotificationCreator from '@/components/notification/items/NotificationCreator';
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            List,
            Viewer,
            Title,
            TitleButton,
            NotificationCreator,
            Confirm
        },
        data: function () {
            return {
                numOfAcruiredOnce: 8,
                isViewNotification: false,
                currentTabIndex: null,
                settingItems: [
                    {tab:"受信", index:0, icon:"mdi-email-receive-outline"},
                    {tab:"送信", index:1, icon:"mdi-email-send-outline"},
                ],
                viewNotification: null,
                groups: []
            }
        },
        // watch: {
        //     "notifications.send": {
        //         handler: function(value, old) {
        //             console.log("notifications.send changed", value)
        //         },
        //         deep: true
        //     }
        // },
        computed: {
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            userData: function () {
                return this.$store.getters["userData"]
            },
            /**
             * 送受信した通知の受信通知リスト
             */
            notificationReceiveList: function () {
                // console.log("notificationReceiveList", this.$store.getters["managementItems/notifications"].receiveList)
                return this.$store.getters["managementItems/notifications"].receiveList
            },
            /**
             * 送受信した通知の送信通知リスト
             */
            notificationSendList: function () {
                // console.log("notificationSendList", this.$store.getters["managementItems/notifications"].sendList)
                return this.$store.getters["managementItems/notifications"].sendList
            }
        },
        created: function () {
            // this.initializeReceiveData()
            // this.refreshReceivedNotification()

            // this.initializeSendData()
            // this.refreshSentNotification()
        },
        methods: {
            // =======================================
            // 受信通知選択時
            onSelectedReceivedNotification: function (notification) {
                this.$refs.viewer.show(notification)
            },
            // =======================================
            // 送信通知選択時
            onSelectedSentNotification: function (notification) {
                this.$refs.viewer.show(notification, false)
            },
            // =======================================
            // 受信通知削除選択時
            // notificaitons: 一覧でチェックされた通知が格納された配列
            onSelectedDeleteReceivedNotifications: function (checkedNotifications) {
                const self = this
                this.confirmDeleteNotifications(function(){
                    var batch = db.batch()
                    var docNotifications = db.collection("users").doc(self.userUID).collection("notifications")
                    var count = 0

                    checkedNotifications.forEach(function(notification) {
                        batch.delete(docNotifications.doc(notification.body.notificationID))
                        count++
                        if (count == checkedNotifications.length) {
                            batch.commit().then(function(){
                                self.$store.commit("notification", {message:"通知を削除しました。"})
                                checkedNotifications.splice(0, checkedNotifications.length)
                            }).catch(function(error){
                                console.log(error)
                                self.$store.commit("notification", {message:"通知の削除に失敗しました。", isError:true})
                            })
                        }
                    })
                })
            },
            // =======================================
            // 送信通知削除選択時
            // notificaitons: 一覧でチェックされた通知が格納された配列
            onSelectedDeleteSentNotifications: function (checkedNotifications) {
                // console.log("onSelectedDeleteSentNotifications", checkedNotifications)
                const self = this
                this.confirmDeleteNotifications(function(){
                    var batch = db.batch()
                    var docNotifications = db.collection("users").doc(self.userUID).collection("sent_notifications")
                    var count = 0

                    checkedNotifications.forEach(function(notification) {
                        batch.delete(docNotifications.doc(notification.body.notification.notificationID))
                        count++
                        if (count == checkedNotifications.length) {
                            batch.commit().then(function(){
                                self.$store.commit("notification", {message:"通知を削除しました。"})
                                checkedNotifications.splice(0, checkedNotifications.length)
                            }).catch(function(error){
                                console.log(error)
                                self.$store.commit("notification", {message:"通知の削除に失敗しました。", isError:true})
                            })
                        }
                    })
                })
            },
            // =======================================
            // 通知作成ボタン押下時
            onClickCreate: function () {
                this.$refs.notificationCreator.show()
            },
            // =======================================
            // 通知作成時
            onSentNotification: function (sentNotification) {
                // this.initializeSendData()
                // this.refreshSentNotification()
            },
            onMoreReceiveList: function () {
                // this.refreshReceivedNotification() !!!
            },
            onMoreSendList: function () {
                // this.refreshSentNotification() !!!
            },
            // initializeReceiveData: function () {
            //     this.notifications.receive.list = []
            //     this.notifications.receive.showMore = true
            // },
            // initializeSendData: function () {
            //     this.notifications.send.list = []
            //     this.notifications.send.showMore = true
            // },
            // =======================================
            // 削除実行確認
            confirmDeleteNotifications: function (callback) {
                const self = this

                this.$refs.confirm.show({
                    title: "削除",
                    message: "チェックされている通知を削除しても宜しいですか？<br/>※削除した通知をもとに戻す事は出来ません。",
                    width: 450,
                    icon: "mdi-alert",
                    buttonYes: "削除する",
                    buttonNo: "しない",
                    listenerYes: function () {
                        callback()
                        return true
                    },
                })
            },
        }
    }
</script>
